import "../../../../styles/productView.scss";
import "../../../../styles/productViewListItem.scss";

import Loading, { loadingTypes } from "../../../common/components/Loading";
import {ProductViewListHeader, ProductViewListItem} from "./ProductViewListItem.jsx";

import {Localization} from "../../../common/util/localization.jsx";
import ProductViewItem from "./ProductViewItem.jsx";
import PropTypes from "prop-types";
import React from "react";
import ResponsiveColumn from "../../../common/components/ResponsiveColumn";
import ResponsiveRows from "../../../common/components/ResponsiveRows";
import Scroll from "../../../common/components/Scroll";

// Component that displays a list of products in two ways:
// Item view: The products are displayed in a table with a form for each product consisting of an image and information below it.
//            This is the ProductViewItem component.
// List view: The products are displayed in a list.
//            This is the ProductViewListItem component.
class ProductView extends React.PureComponent {
    constructor(props){
        super(props);

        this.state = {
            width: null,
        };
        this.containerNode = null;

        this.trackScrolling = this.trackScrolling.bind(this);

        this.prepareItems = this.prepareItems.bind(this);
    }

    trackScrolling() {
        const {
            loadMoreProducts,
            isLoading,
        } = this.props;

        //load more products if none is loading
        if( isLoading===false && loadMoreProducts){
            loadMoreProducts(50);
        }
    }

    prepareItems(view) {
        const {
            deviceType,
            localization,
            addRemoveProductToTemporaryOrder,
            list,
            isLoading,
            activeOrder,
            setModal,
            countProductsInList,
            countingNode,
            onMyListEdit,
        } = this.props;

        const retNodes = [];

        for(let i=0; i<list.length; i++){
            retNodes[retNodes.length] = view==="item" ? (
                //column size for row is 24
                <ResponsiveColumn key={i} xs={12} sm={12} md={6} lg={4} xl={3}>
                    <ProductViewItem
                        localization={localization}
                        product={list[i].product}
                        addRemoveProductToTemporaryOrder={addRemoveProductToTemporaryOrder}
                        countProductsInList={countProductsInList}
                        activeOrder={activeOrder}
                        setModal={setModal}
                        onMyListEdit={onMyListEdit}
                        countingNode={countingNode}/>
                </ResponsiveColumn>
            ) : (
                <ProductViewListItem
                    key={i}
                    localization={localization}
                    product={list[i].product}
                    deviceType={deviceType}
                    addRemoveProductToTemporaryOrder={addRemoveProductToTemporaryOrder}
                    list={activeOrder}
                    setModal={setModal}
                    countingNode={countingNode}/>
            );
        }
        if( isLoading ) {
            retNodes[retNodes.length] = (
                retNodes[retNodes.length] = view==="item" ? (
                    <ResponsiveColumn key={retNodes.length.toString()} xs={12} sm={12} md={6} lg={4} xl={3}>
                        <Loading height={list.length>0?"66%":"100%"} width="100%" loadingSize={75} points={12} lapTime={2}/>
                    </ResponsiveColumn>
                ) : (
                    <Loading key={"view-list-loading"} height={48} type={loadingTypes.line} />
                )
            );
        }

        return retNodes;
    }

    render(){
        const {
            deviceType,
            localization,
            view,
            height,
            style,
            loadMoreProducts,
            editQueryFilter,
        } = this.props;

        const nodes = this.prepareItems(view);

        return (
            <React.Fragment>
                {view==="list" && (
                    <div className={"product-view-header-wrapper"} >
                        <ProductViewListHeader localization={localization} deviceType={deviceType} loadMoreProducts={loadMoreProducts} editQueryFilter={editQueryFilter}/>
                    </div>
                )}
                <Scroll style={{height: height?(height-(view==="item"?0:33)):undefined, overflowX:"hidden", ...style}} className={"product-view-items-wrapper"} onCloseToBottom={this.trackScrolling} shadowStyle={{borderBottomRightRadius:"8px",borderBottomLeftRadius:"8px"}}>
                    {view==="item" ? (
                        <ResponsiveRows columns={24}>
                            {nodes}
                        </ResponsiveRows>
                    ) : (
                        nodes
                    )}
                </Scroll>
            </React.Fragment>
        );
    }
}

ProductView.propTypes = {
    deviceType: PropTypes.string.isRequired,
    localization: Localization.propTypes.isRequired,
    activeOrder: PropTypes.object.isRequired,
    view: PropTypes.string.isRequired,
    height: PropTypes.number,
    style: PropTypes.object,
    addRemoveProductToTemporaryOrder: PropTypes.func.isRequired,
    editQueryFilter: PropTypes.func,
    setModal: PropTypes.func.isRequired,
    countingNode: PropTypes.node.isRequired,
    // An array of products to be displayed
    list: PropTypes.array.isRequired,
    // A function that will load in more items into list
    loadMoreProducts: PropTypes.func,
    // If true a loading icon will be displyed
    isLoading: PropTypes.bool,
    // Method to count product in list
    countProductsInList: PropTypes.func,
    onMyListEdit: PropTypes.func,
};

export default ProductView;